<template>
  <router-view :key="$route.path"></router-view>
</template>

<style lang="scss">
/* Force a full screen modal that covers the nav when set; Used for directors page */
.force-fullscreen {
  z-index: 10001 !important;

  & + .md-overlay {
    z-index: 10000 !important;
  }
}
</style>

<script>
import { isUserLoggedin, isAdmin } from '@/lib/utils';

export default {
  data() {
    return {
      mouseEvents: ['mousemove', 'mousedown', 'keypress', 'scroll', 'click'],
      idleTimeout: null,
      maxWindowLimit: this.$constants.minSessionWindowLimit,
      maxIdleTime: 0,
      touchInterval: 60 * this.$constants.touchSessionInterval * 1000,
      touchIntervalId: null,
    };
  },

  methods: {
    async logoutUser() {
      if (!isUserLoggedin()) return;

      await this.$logout(this);
      this.notification(`You have been logged out due to inactivity for ${this.maxWindowLimit} minutes.`, 'error', 'danger');
    },

    resetIdleTimer() {
      clearTimeout(this.idleTimeout);
      this.idleTimeout = setTimeout(() => {
        this.logoutUser();
      }, this.maxIdleTime);
    },

    handleUserActivity() {
      this.resetIdleTimer();
    },

    setupEventListeners() {
      this.mouseEvents.forEach(event => {
        window.removeEventListener(event, this.handleUserActivity);
        window.addEventListener(event, this.handleUserActivity);
      });
    },

    async callTouch() {
      if (!isUserLoggedin()) return;

      if (isAdmin()) this.maxWindowLimit = this.$constants.maxSessionWindowLimit;

      try {
        await this.$http.post('touch', { method: 'POST' }, { params: { skipLoader: true } });
      } catch {
        this.notification('Unable to refresh session.', 'warning', 'danger');
      }
    },

    setupTouchInterval() {
      clearInterval(this.touchIntervalId);
      this.touchIntervalId = setInterval(() => {
        this.callTouch();
      }, this.touchInterval);
    },

    clearListenersAndIntervals() {
      this.mouseEvents.forEach(event =>
        window.removeEventListener(event, this.handleUserActivity)
      );
      clearInterval(this.touchIntervalId);
      clearTimeout(this.idleTimeout);
    },

    startTouch() {
      this.clearListenersAndIntervals();
      this.setMaxIdleTime();
      this.setupEventListeners();
      this.setupTouchInterval();
      this.callTouch();
    },

    setMaxIdleTime() {
      this.maxIdleTime = 60 * this.maxWindowLimit * 1000;
    },

    notification(message, icon, color) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: color,
      });
    }
  },

  mounted() {
    this.startTouch();
  },

  watch: {
    maxWindowLimit() {
      this.setMaxIdleTime();
      this.startTouch();
    }
  }
};
</script>
